import app from 'flarum/forum/app';
import addCaptionButtons from './addCaptionButtons';
export { default as extend } from './extend';
app.initializers.add('champis-captions', () => {
  addCaptionButtons();
});